import {ajax,getRequestUrl,formatData} from "../request";

export default {
  // 道具商城--列表
  findShopList(data, method) {
    return ajax('post', getRequestUrl('/prop/list'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 道具商城--上下架
  shopIsOn(data, method) {
    return ajax('post', getRequestUrl('/prop/setOn'), data, {
      method,
    })
  },

  // 道具商城--设置/取消出售道具
  cancelSaleShop(data, method) {
    return ajax('post', getRequestUrl('/prop/setPay'), data, {
      method,
    })
  },

  // 道具商城--道具详情
  shopInfo(data, method) {
    return ajax('post', getRequestUrl('/prop/detail'), data, {
      method,
    })
  },

  // 道具商城--保存道具信息
  shopSaveData(data, method) {
    return ajax('post', getRequestUrl('/prop/save'), data, {
      method,
    })
  },

  // 道具商城--销售统计列表
  findShopSalesData(data, method) {
    return ajax('post', getRequestUrl('/api/Shop/findShopSalesData'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 卡券-卡券列表
  findShopCouponsList(data, method) {
    return ajax('post', getRequestUrl('/card/list'), data, {
      method,
    })
  },
  // 道具商城--卡券详情
  findShopCouponsInfo(data, method) {
    return ajax('post', getRequestUrl('/api/Shop/findShopCouponsInfo'), data, {
      method,
    })
  },

  // 道具商城--保存卡券信息
  findShopCouponsSave(data, method) {
    return ajax('post', getRequestUrl('/card/save'), data, {
      method,
    })
  },
  // 道具商城--设置道具分区
  setRegionProp(data, method) {
    return ajax('post', getRequestUrl('/api/Shop/setRegionProp'), data, {
      method,
    })
  },

  // 道具商城--删除分区道具
  deleteRegionProp(data, method) {
    return ajax('post', getRequestUrl('/api/Shop/deleteRegionProp'), data, {
      method,
    })
  },

  // 道具商城--用户列表
  PropUserListByPage(data, method) {
    return ajax('post', getRequestUrl('/api/Shop/PropUserListByPage'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 道具商城--道具推荐
  recommendShopList(data, method) {
    return ajax('post', getRequestUrl('/api/Shop/recommendShopList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },
  // 道具商城--道具推荐保存接口
  recommendShopSave(data, method) {
    return ajax('post', getRequestUrl('/api/Shop/recommendShopSave'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 道具商城--svip定制装饰审核列表
  svipCustomDecoration(data, method) {
    return ajax('post', getRequestUrl('/api/Shop/svipCustomDecoration'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },
  // 道具商城--svip定制装饰审核
  svipCustomDecorationCheck(data, method) {
    return ajax('post', getRequestUrl('/api/Shop/svipCustomDecorationCheck'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 自定义房间背景列表
  roomBGCustomList(data, method) {
    return ajax('post', getRequestUrl('/room/background/custom/list'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },
  // 自定义房间背景删除
  roomBGCustomBatchDelete(data, method) {
    return ajax('post', getRequestUrl('/room/background/custom/batchDelete'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },
}



// WEBPACK FOOTER //
// ./src/js/https/shop.js